import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { OktaAuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent {

  constructor(private okta: OktaAuthService, private router: Router) {}

  async ngOnInit()
  {    
      const authenticated = await this.okta.isAuthenticated();
      if (authenticated) { 
        this.router.navigate(['/','home']);
        return true; 
      }
  
      // Redirect to login flow.
      this.okta.login('/home');
      return false;
    
  }

  // handleLogIn() {
  //   localStorage.setItem('token', '123');
  //   this.route.navigate(['/home']);
  // }
}
